import React from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { Button } from '../../button';

interface Props {
  onSelectMinute: (data: number) => void;
  displayDate: Dayjs;
}

const PopulateMinute = ({ onSelectMinute, displayDate }: Props) => {
  const displayHour = dayjs(displayDate).get('hour');
  const displayMinute = dayjs(displayDate).get('minute');

  return (
    <div className="d-flex justify-content-between align-items-start">
      <div className="d-flex flex-wrap gap-4 px-8">
        {Array(12)
          .fill(0)
          .map((_item, index) => {
            const minute = dayjs()
              .minute(index * 5)
              .format('mm');
            return (
              <Button
                className="p-4"
                key={index}
                onClick={() => onSelectMinute(index * 5)}
                type={displayMinute === Number(minute) ? 'primary' : 'default'}
              >
                {displayHour}:{minute}
              </Button>
            );
          })}
      </div>
    </div>
  );
};

export default PopulateMinute;
